export enum EnumAcaoManifesto {
    EventoDeCartaDeCorrecao = 110110,
    Cancelamento = 1,
    EventosDeConfirmacaoDeOperacao = 210200,
    EventosDeCienciaDaOperacao = 210210,
    EventosDeDesconhecimentoDaOperacao = 210220,
    EventosDeOperacaoNaoRealizada = 210240,
}